// BUG-4143: display-time normalization for SCORM raw score.
// Data model: session.score — raw value from SCORM (points or percent),
// session.scoreMin / session.scoreMax — range from cmi.core.score.min/max.
// Display code must always use formatScoreDisplay, never `${score}%`.

export const normalizeScore = (
  score: number | null | undefined,
  scoreMin: number | null | undefined = 0,
  scoreMax: number | null | undefined = 100,
): number | null => {
  if (score === null || score === undefined) {
    return null
  }
  const min = scoreMin ?? 0
  const max = scoreMax ?? 100
  const range = max - min
  if (range <= 0) {
    return null
  }
  const normalized = ((score - min) / range) * 100
  return Math.max(0, Math.min(100, Math.round(normalized)))
}

export const formatScoreDisplay = (
  score: number | null | undefined,
  scoreMin: number | null | undefined,
  scoreMax: number | null | undefined,
): string => {
  const normalized = normalizeScore(score, scoreMin, scoreMax)
  return normalized === null ? '—' : `${normalized}%`
}
